import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';

function EditDeleteBtn({ row, thunkFunc, withoutNavigation, setShowModal, setEditedRow, hasDelete, queryParam }) {
    const id = row.id;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const destroyItem = () => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            confirmButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(thunkFunc({ navigate, id }));
            }
        });
    };

    return (
        <>
            {withoutNavigation ? (
                <Button
                    size="sm"
                    className={'bg-info  border border-info mr-4'}
                    onClick={() => {
                        setShowModal(true);
                        setEditedRow(row);
                    }}
                >
                    <FontAwesomeIcon icon={faPencil} />
                </Button>
            ) : (
                <Link to={`update/${id}` + queryParam}>
                    <Button
                        size="sm"
                        className={'bg-info  border border-info mr-4'}
                    >
                        <FontAwesomeIcon icon={faPencil} />
                    </Button>
                </Link>
            )}
            {hasDelete && (
                <Button
                    size="sm"
                    className={'bg-danger border border-danger'}
                    onClick={destroyItem}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            )}
        </>
    );
}

EditDeleteBtn.defaultProps = {
    withoutNavigation: false,
    setShowModal: null,
    setEditedRow: null,
    hasDelete: true,
    thunkFunc: null,
    queryParam: '',
};
EditDeleteBtn.propTypes = {
    row: PropTypes.object.isRequired,
    thunkFunc: PropTypes.func,
    withoutNavigation: PropTypes.bool,
    setShowModal: PropTypes.func,
    setEditedRow: PropTypes.func,
    hasDelete: PropTypes.bool,
    queryParam: PropTypes.string,
};

export default EditDeleteBtn;
